import { render, staticRenderFns } from "./InputLabelPlaceholder.vue?vue&type=template&id=e14e6170&"
import script from "./InputLabelPlaceholder.vue?vue&type=script&lang=js&"
export * from "./InputLabelPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports